import contact from "./contact";
import websiteFAQ from "./faq";
import websiteFeatures from "./features";
import freelancer from "./freelancer";
import pricing from "./pricing";
import roadmap from "./roadmap";
import websiteSignup from "./signup";
import verifyEmailToken from "./verify-email-token";
import tools from "./tools";

export default {
  en: {
    // Subpages
    faq: websiteFAQ.en,
    signup: websiteSignup.en,
    features: websiteFeatures.en,
    verifyEmailToken: verifyEmailToken.en,
    contact: contact.en,
    roadmap: roadmap.en,
    freelancer: freelancer.en,
    pricing: pricing.en,
    tools: tools.en,

    // Website
    professional_timetracking: "Professional Time Tracking",
    customer_management: "Customer Management",
    projects: "Projects",
    reporting: "Reporting",
    freelancer_key: "Freelancer",
    for_freelancers: "For Freelancers",
    companies: "Companies",
    for_companies: "For Companies",
    learn_more: "Learn More",
    learn_more_description:
      "ChronoFox is the smart software solution for freelancers and businesses to efficiently manage their working hours, clients, and projects. Track your activities with hourly rates, easily organize clients and projects, and keep your time entries up to date. With multi-user support, flexible time tracking, and a clear overview of work packages and budgets, ChronoFox brings structure and efficiency to your daily workflow. Simply register, subscribe, and get started right away!",
    for_whom: "For Whom?",
    for_freelancers_description:
      "Discover features tailored for freelancers to manage projects and time.",
    for_companies_description:
      "Explore how companies can streamline time tracking and project management.",
    detailed_features: "Detailed Features",
    all_features: "All Features",
    as_your_companion:
      "as your companion for professional time tracking: Track time, manage projects, organize clients, and keep an eye on budgets.",

    not_convinced_not_convinced_question_no_problem_excalamation:
      "Not convinced? No problem!",
    convince_yourself_via_our_subpages: "Convince yourself via our subpages",
    get_convinced_from_freelancer_page: "For Freelancers",
    get_convinced_from_companies_page: "For Companies",
    and_remember_we_offer_free_trials: "And remember, we offer free trials",
    time_tracking: "Time Tracking",
    billing_and_open_items: "Billing and Open Items",
    revenue_statistics: "Revenue Statistics",
    projects_and_budgets: "Projects and Budgets",
    reporting_in_pdf_and_csv: "Reporting in PDF and CSV",
    time_tracking_of_work_and_project_times:
      "Time tracking of work and project times",
    always_with_you_on_mobile: "Always with you on mobile",
    always_with_you_on_mobile_description:
      "ChronoFox is also optimized for mobile. Track your time on the go, manage your projects and clients, and keep an eye on your budgets – all from your smartphone or tablet. Start a free trial today and have time tracking with you wherever you go!",
    view_pricing: "View Pricing",
  },
  de: {
    // Subpages
    faq: websiteFAQ.de,
    signup: websiteSignup.de,
    features: websiteFeatures.de,
    verifyEmailToken: verifyEmailToken.de,
    contact: contact.de,
    roadmap: roadmap.de,
    freelancer: freelancer.de,
    pricing: pricing.de,
    tools: tools.de,

    // Website
    professional_timetracking: "Professionelle Zeiterfassung",
    customer_management: "Kundenmanagement",
    projects: "Projekte",
    reporting: "Berichterstattung",
    freelancer_key: "Freelancer",
    for_freelancers: "Für Freelancer",
    companies: "Unternehmen",
    for_companies: "Für Unternehmen",
    learn_more: "Erfahren Sie mehr",
    learn_more_description:
      "ChronoFox ist die smarte Softwarelösung für Selbstständige und Unternehmen, die ihre Arbeitszeiten, Kunden und Projekte effizient verwalten möchten. Erfassen Sie Ihre Aktivitäten inklusive Stundensätzen, verwalten Sie Kunden und Projekte mit Leichtigkeit und halten Sie Ihre Zeiteinträge stets im Blick. Mit Multi-User-Support, flexibler Zeiterfassung und einer klaren Übersicht über Arbeitspakete und Budgets bringt ChronoFox Struktur und Effizienz in Ihren Arbeitsalltag. Einfach registrieren, Abo abschließen und direkt loslegen!",
    for_whom: "Für wen?",
    for_freelancers_description:
      "ChronoFox ist die ideale Lösung für Freelancer, die ihre Zeit professionell erfassen möchten, ohne sich in komplizierte Tools einarbeiten zu müssen. Die intuitive Benutzeroberfläche erlaubt es Ihnen, Ihre Arbeitszeiten präzise zu erfassen und diese Aktivitäten direkt Ihren Projekten und Kunden zuzuordnen. Erstellen Sie übersichtliche Berichte über Ihre Zeiteinträge, Projekte und Kunden – ideal für eine transparente Abrechnung. Mit der integrierten Verwaltung von Stundensätzen und klaren Statistiken behalten Sie Ihre Einnahmen jederzeit im Blick. ChronoFox vereint Einfachheit mit professionellen Funktionen, die Sie als Selbstständiger benötigen, um effizient und erfolgreich zu arbeiten.",
    for_companies_description:
      "Mit ChronoFox bringen Sie Struktur in die Zeiterfassung Ihres Unternehmens. Ob Arbeitsstunden, Projekte oder Urlaubszeiten – die Software ist perfekt für Teams, die harmonisch und effizient zusammenarbeiten möchten. Die benutzerfreundliche Oberfläche sorgt dafür, dass jeder im Team schnell loslegen kann. Gleichzeitig bietet ChronoFox Ihnen die Möglichkeit, Projekte und Arbeitspakete mit präzisen Stundensätzen zu verwalten und so Ihre Budgets optimal zu nutzen. Fördern Sie die Zusammenarbeit in Ihrem Unternehmen, ohne dabei den Fokus auf eine zuverlässige Zeiterfassung zu verlieren.",
    detailed_features: "Detaillierte Funktionen",
    all_features: "Alle Funktionen",
    as_your_companion:
      "als Ihr Begleiter für professionelles Zeitmanagement: Zeiten erfassen, Projekte verwalten, Kunden organisieren und Budgets im Blick behalten.",

    not_convinced_not_convinced_question_no_problem_excalamation:
      "Noch nicht überzeugt? Kein Problem!",
    convince_yourself_via_our_subpages:
      "Überzeugen Sie sich über unsere Unterseiten",
    get_convinced_from_freelancer_page: "Für Freelancer",
    get_convinced_from_companies_page: "Für Unternehmen",
    and_remember_we_offer_free_trials:
      "Und denken Sie daran, wir bieten kostenlose Testversionen",
    time_tracking: "Zeiterfassung",
    billing_and_open_items: "Abrechnung und offene Posten",
    revenue_statistics: "Umsatzstatistiken",
    projects_and_budgets: "Projekte und Budgets",
    reporting_in_pdf_and_csv: "Berichterstattung in PDF und CSV",
    time_tracking_of_work_and_project_times:
      "Zeiterfassung von Arbeits- und Projektzeiten",
    always_with_you_on_mobile: "Immer dabei auf dem Handy",
    always_with_you_on_mobile_description:
      "ChronoFox ist auch für mobil optimiert. Erfassen Sie Ihre Zeiten unterwegs, verwalten Sie Ihre Projekte und Kunden und behalten Sie Ihre Budgets im Blick – alles von Ihrem Smartphone oder Tablet aus. Heute noch ein kostenlosen Test starten und die Zeiterfassung immer dabei haben!",
    view_pricing: "Preise ansehen",
  },
};
